import axios from "axios";
const test = axios.create({
  baseURL: process.env.NODE_ENV == "production" ? "" : "/test",
});

test.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  config.headers["ypSource"] = "H5";
  return config;
});

export default test;
